import { AdvancedFilterModel, FilterModel, SortModelItem } from 'ag-grid-community';
import { signalStore } from '@ngrx/signals';
import { TransactionActions } from './transaction.action';
import { TransactionState } from './transaction.state';
import { OffSubscriptionWithCatch, withSelectors, withActions } from '@res/ngg-core';
import { TransactionData, TransactionRef } from '../../schema/schema.interface';

export type TransactionStoreModel = TransactionData & { ref: TransactionRef };

export interface TransactionStateModel {
  transactions: TransactionStoreModel[];
  isSubscribed: boolean;
  off?: OffSubscriptionWithCatch;
  count?: number;
  isLoading: boolean;
  filter?: FilterModel | AdvancedFilterModel | null;
  sort: SortModelItem[];
  sums?: { [key: string]: { sum: number; count: number } };
}

export const TransactionStore = signalStore(
  { protectedState: false },
  withSelectors({
    // sumsByParams: TransactionState.sumsByParams,
    sums: TransactionState.sums,
    transactions: TransactionState.transactions,
    transactionsCount: TransactionState.transactionsCount,
    transactionState: TransactionState.transactionState,
  }),
  // Actions
  withActions({
    GetSumsCountOf: TransactionActions.GetSumsCountOf,
    getAllTransactions: TransactionActions.GetAllTransaction,
    deleteTransactions: TransactionActions.DeleteTransactions,
    initTransactions: TransactionActions.InitTransactions,
    initTransactionsCount: TransactionActions.InitTransactionsCount,
    updateTransaction: TransactionActions.UpdateTransaction,
    paginateQueryTransaction: TransactionActions.PaginateQueryTransaction,
  }),
);
